export const metrics = [
  { value: 137, suffix: "", label: "Completed Projects", pad: 0 },
  { value: 6, suffix: "", label: "Ongoing Projects", pad: 0 },
  { value: 100, suffix: "+", label: "People", pad: 0 },
  { value: 2, suffix: "", label: "Locations", pad: 0 },
];

export const homeServices = [
  {
    num: "01",
    title: "Web Development",
    visual: "web",
    text: "High-performance web platforms built with React, designed for scale and long-term ownership.",
  },
  {
    num: "02",
    title: "Mobile App Development",
    visual: "mobile",
    text: "Cross-platform iOS and Android products with React Native, from first release to production scale.",
  },
  {
    num: "03",
    title: "UI/UX Design",
    visual: "design",
    text: "Product interfaces with clear hierarchy, accessibility, and a premium visual system.",
  },
  {
    num: "04",
    title: "Software Engineering",
    visual: "code",
    text: "Custom product engineering — APIs, platforms, and internal systems built to last.",
  },
  {
    num: "05",
    title: "Cloud Solutions",
    visual: "cloud",
    text: "AWS architecture, CI/CD, and infrastructure that stays observable and cost-aware.",
  },
  {
    num: "06",
    title: "AI & Automation",
    visual: "ai",
    text: "Practical machine learning, analytics, and workflow automation for real operations.",
  },
  {
    num: "07",
    title: "API Development",
    visual: "api",
    text: "Secure, documented APIs that connect products, partners, and internal tools.",
  },
  {
    num: "08",
    title: "Digital Transformation",
    visual: "transform",
    text: "Modernising processes and platforms so teams can ship faster with less friction.",
  },
  {
    num: "09",
    title: "Enterprise Solutions",
    visual: "enterprise",
    text: "SAP, testing, cybersecurity, and specialised domain delivery for growing businesses.",
  },
];

export const technologies = [
  {
    group: "Frontend",
    items: [
      { name: "React", note: "Product interfaces and web platforms" },
      { name: "React Native", note: "Shared mobile experiences for iOS and Android" },
      { name: "JavaScript", note: "Application logic across the product surface" },
    ],
  },
  {
    group: "Backend",
    items: [
      { name: "Python", note: "Services, data, and product APIs" },
      { name: "Django", note: "Secure, structured backend platforms" },
      { name: "Node.js", note: "Realtime and integration-heavy services" },
    ],
  },
  {
    group: "Database",
    items: [
      { name: "PostgreSQL", note: "Relational systems for product data" },
      { name: "MongoDB", note: "Flexible document stores where the model needs it" },
    ],
  },
  {
    group: "Cloud",
    items: [{ name: "AWS", note: "Infrastructure, delivery, and operations" }],
  },
  {
    group: "Realtime",
    items: [
      { name: "WebRTC", note: "Peer connections for live experiences" },
      { name: "WebSockets", note: "Live updates across riders, ops, and apps" },
    ],
  },
  {
    group: "Enterprise",
    items: [{ name: "SAP", note: "FICO, MM, SD, PP implementation and support" }],
  },
  {
    group: "Payments",
    items: [{ name: "Razorpay", note: "Checkout and collections inside products" }],
  },
  {
    group: "Notifications",
    items: [{ name: "Firebase", note: "Messaging, alerts, and device reach" }],
  },
];

export const whyPoints = [
  {
    num: "01",
    title: "Product-first thinking",
    text: "We start with the problem, the user, and the system that has to keep working after launch.",
  },
  {
    num: "02",
    title: "Modern engineering",
    text: "React, Python, cloud, and a stack chosen for maintainability — not fashion.",
  },
  {
    num: "03",
    title: "Scalable architecture",
    text: "Platforms designed to grow with users, traffic, and operational complexity.",
  },
  {
    num: "04",
    title: "Human-centered design",
    text: "Interfaces with hierarchy, restraint, and accessibility built in from the start.",
  },
  {
    num: "05",
    title: "Business-focused solutions",
    text: "Technology that maps to operations, revenue, and the work people actually do.",
  },
  {
    num: "06",
    title: "Long-term partnership",
    text: "We stay after launch — iterating, operating, and owning outcomes with you.",
  },
];

export const offices = [
  {
    tag: "Headquarters",
    city: "Tirupati",
    region: "Andhra Pradesh, India",
    text: "Product, engineering, and company home.",
    address: "KKR Heights, Flat Nos. 401 & 402, D.No. 23-8-158, Air Bypass Rd, New Balaji Colony, Tirupati, Andhra Pradesh 517502",
    map: "https://maps.app.goo.gl/Ck5BcdLLZoVY5SueA",
  },
  {
    tag: "Presence",
    city: "Bangalore",
    region: "Karnataka, India",
    text: "Delivery, clients, and collaboration.",
    address: "01, Hennur Main Rd, PO, opposite to Yulu Center, HRBR Layout, Kalyan Nagar, Bengaluru, Karnataka 560043",
    map: "https://www.google.com/maps/search/?api=1&query=01%2C%20Hennur%20Main%20Rd%2C%20PO%2C%20opposite%20to%20Yulu%20Center%2C%20HRBR%20Layout%2C%20Kalyan%20Nagar%2C%20Bengaluru%2C%20Karnataka%20560043",
  },
];

export const values = [
  {
    num: "01",
    title: "Innovation",
    text: "We explore technologies people will actually use — not novelty for its own sake.",
  },
  {
    num: "02",
    title: "Craft",
    text: "Quality in architecture, interface, and operations. Customers should feel the difference.",
  },
  {
    num: "03",
    title: "Community",
    text: "Products for students, professionals, devotees, and businesses across India.",
  },
  {
    num: "04",
    title: "Impact",
    text: "Homegrown platforms that create local talent and lasting societal value.",
  },
];

export const timeline = [
  {
    title: "Founded",
    text: "Started in Tirupati to build homegrown technology with local talent.",
  },
  {
    title: "Growth",
    text: "Grew into a 100+ person product, design, and engineering team.",
  },
  {
    title: "Products",
    text: "Shipped live platforms across education, mobility, finance, travel, and logistics.",
  },
  {
    title: "Expansion",
    text: "Established a Bangalore presence alongside the Tirupati headquarters.",
  },
  {
    title: "Today",
    text: "A product studio and technology partner for teams building what is next.",
  },
];

export const companyLinks = [
  { label: "About", to: "/About", description: "Who we are, mission, and locations" },
  { label: "FAQ", to: "/FAQ", description: "Common questions about working with us" },
  { label: "Privacy", to: "/PrivacyPolicy", description: "How we handle information" },
  { label: "Terms", to: "/TermsConditions", description: "Website terms of use" },
];

export const insightLinks = [
  { label: "FAQ", to: "/FAQ", description: "Answers about products, services, and working with us" },
  { label: "Privacy Policy", to: "/PrivacyPolicy", description: "How we handle information" },
  { label: "Terms of Use", to: "/TermsConditions", description: "Website terms of use" },
];

export const aboutHighlights = [
  "Customer-centric product thinking",
  "Innovative and scalable solutions",
  "Agile, transparent delivery",
  "Quality and long-term ownership",
];

export const industries = [
  {
    title: "Education",
    text: "Curriculum-aligned learning platforms that help students, parents, and institutions stay connected.",
    to: "/StudentBook",
    icon: "book",
  },
  {
    title: "Transportation",
    text: "Ride-booking and mobility systems with live tracking, payments, and driver operations.",
    to: "/HappyRide",
    icon: "nav",
  },
  {
    title: "Startups",
    text: "Platforms that help founders move from a strong idea to a venture they can actually start.",
    to: "/BusinessGuider",
    icon: "zap",
  },
  {
    title: "Travel & Faith",
    text: "Respectful digital companions for pilgrimage planning, travel, and family journeys.",
    to: "/TirumalaYatra",
    icon: "map",
  },
  {
    title: "Banking & Finance",
    text: "Clear money products and mortgage operations support for individuals and institutions.",
    to: "/MyFinaz",
    icon: "card",
  },
  {
    title: "Logistics",
    text: "Last-mile delivery, fleet workflows, and live visibility from pickup to drop.",
    to: "/Mobotos",
    icon: "truck",
  },
  {
    title: "Healthcare",
    text: "Medical coding, billing, and compliance support for healthcare operations.",
    to: "/Services",
    icon: "heart",
  },
  {
    title: "Enterprise",
    text: "SAP, cybersecurity, and specialised domain delivery for growing organisations.",
    to: "/Services",
    icon: "briefcase",
  },
];
